// extracted by mini-css-extract-plugin
export var table = "_v3-0";